export default __webpack_public_path__ + "static/sol-section-1-img-0623ed3b318e844e3f30892a97134f3b.png";